<script lang="ts">
type Props = {
	value?: string
	text?: string
}

let { value = '', text = '' }: Props = $props()
</script>

<option {value}>{text || value}</option>
